module.exports = __webpack_public_path__ + "static/img/1-1.1574d2f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/12/eng/1-1.png
// module id = VGDY
// module chunks = 0